'use strict';

angular.module('app.notificationDiscoverCondition', [])

.controller('notificationDiscoverConditionCtrl', function ($scope, $rootScope, $http, $modal, $compile) {
    var definitions = angular.copy($rootScope.definitions);
    $scope.growth = [
        {id: 1, value: 10},
        {id: 2, value: 20},
        {id: 3, value: 30},
        {id: 4, value: 40},
        {id: 5, value: 50},
        {id: 6, value: 60},
        {id: 7, value: 70},
        {id: 8, value: 80},
        {id: 9, value: 90},
        {id: 10, value: 100}
    ];

    $scope.minImpactList = [
        {id: 2, value: 25},
        {id: 1, value: 50},
        {id: 2, value: 75},
        {id: 2, value: 100},
        {id: 2, value: 125},
        {id: 2, value: 150},
        {id: 2, value: 175},
        {id: 2, value: 200}
    ];

    $scope.minEngagementList = [
        {id: 2, value: 5000},
        {id: 1, value: 10000},
        {id: 2, value: 15000},
        {id: 2, value: 20000},
        {id: 2, value: 25000},
        {id: 2, value: 50000},
        {id: 2, value: 75000},
        {id: 2, value: 100000}
    ];

    $scope.minReachList = [
        {id: 2, value: 5000},
        {id: 1, value: 10000},
        {id: 2, value: 15000},
        {id: 2, value: 20000},
        {id: 2, value: 25000},
        {id: 2, value: 50000},
        {id: 2, value: 75000},
        {id: 2, value: 100000}
    ];

    $scope.unexistingClick = function(tagToDefine, $event) {
        var unexistingMention = $event.target;
        var typeid = null;
        var tagElement = unexistingMention.parentElement;
        var DomainPatter = new RegExp(/^(?!:\/\/)([a-zA-Z0-9]+\.)?[a-zA-Z0-9-]+\.([a-zA-Z]{2,6}|[a-zA-Z]{2,6}.[a-zA-Z]{2,6})?$/i);
        if(!DomainPatter.test(tagToDefine) && tagToDefine.indexOf("#") != 0){
          typeid = 1;
        } else if(DomainPatter.test(tagToDefine) && tagToDefine.indexOf("#") != 0){
          typeid = 2;
        } else if(!DomainPatter.test(tagToDefine) && tagToDefine.indexOf("#") == 0){
          typeid = 3;
        }

        $rootScope.newMentionModalHandler(tagToDefine, typeid, $scope.allLanguage, function(newMention) {
            if(newMention){
                var newSpan = $compile('<span class="txt-waitapprove">+ Wait For Approve&nbsp;</span><img src="/images/question.gif" class="questionMention">')($scope);
                $(tagElement).find('.unexisting').remove();
                $(tagElement).find('.questionMention').remove();
                $(tagElement).append(newSpan);
                $scope.conditionItem.valueToCompare.name = newMention.keyword;
            } else {
                console.log('cancel');
            }
        });
    }

    $scope.initTagit = function() {
        $scope.element.find("#mentionTagit").tagit({
            allowDuplicates: false,
            allowSpaces: true,
            removeConfirmation: true,
            tagLimit: 1,
            caseSensitive: false,
            autocomplete: ({
                source: function (request, response) {
                    var data = {
                        searchMention: request.term
                    }
                    var req = {
                        url: $rootScope.apiUrl + 'discover/getRelativeMention',
                        method: 'POST',
                        loader: false,
                        data: JSON.stringify(data)
                    }
                    var relativeMention = [];
                    $http(req).success(function (dataResponse){
                        angular.forEach(dataResponse.data, function(item) {
                            var reMention = {
                                label: item.keyword,
                                value: item.keyword
                            };
                            relativeMention.push(reMention);
                        });
                        response(relativeMention);
                    });
                },
                delay: 0,
                minLength: 1
            }),
            // availableTags: availableTags(),

            beforeTagAdded: function (event, ui) {
                if(ui.tagLabel.split(' ').length >= 3)
                {
                    $scope.element.find('.tagit-new').popover({content: '<div class="text-danger" style="width: 200px;word-wrap:break-word;">Keyword is not valid, should input only 1 or 2 words</div>', html: true});
                    $scope.element.find('.tagit-new').popover('show');
                    event.stopPropagation();
                    return false;
                }
                $scope.element.find('.tagit-new').popover('destroy');
            },
            onTagClicked: function (event, ui) {
                
            },
            afterTagAdded: function (event, ui) {
                var isNewTag = false;
                var id = 0;
                var label = encodeURIComponent(ui.tagLabel);

                $scope.element.find(".tagit-new").hide();

                $http.get($rootScope.apiUrl + "mention/existingMentionDiscover?mention=" + label, {loader: false}).
                    success(function (response) {
                        id = response.data.id;
                        if (id == null) {
                            isNewTag = true;
                        } 

                        if(isNewTag){
                            var newMention = $compile('<a class="unexisting" role="button" ng-click="unexistingClick(\'' + ui.tagLabel + '\', $event)">+ New Mention&nbsp;</a><img src="/images/question.gif" class="questionMention">')($scope);
                            ui.tag.append(newMention);
                        } else {
                            $scope.conditionItem.valueToCompare.name = response.data.keyword;
                            ui.tag.children(".tagit-label").get(0).text = response.data.keyword;
                            if(response.data.approved == 2){
                                var newMention = $compile('<span class="txt-waitapprove">+ Wait For Approve&nbsp;</span><img src="/images/question.gif" class="questionMention">')($scope);
                                ui.tag.append(newMention);
                            }
                        }

                    }).error(function (response) {
                        alert("We cannot get info about this keyword, please try again...")
                        console.log(response.data);
                    });
            },
            beforeTagRemoved: function(event, ui) {
                
            },
            afterTagRemoved: function (event, ui) {
                $scope.conditionItem.valueToCompare.name = "";
                $scope.element.find(".tagit-new").show();
            }

        }); 

        if($scope.conditionItem.valueToCompare && $scope.conditionItem.valueToCompare.name) {
            $scope.element.find("#mentionTagit").tagit("createTag", $scope.conditionItem.valueToCompare.name); 
        }
    }

    function checkAddNewCondition(){
        if(!$scope.addNewCondition){
            var selectedConditionTypeId = 0;
            $scope.conditionOperator = 0;
            $scope.conditionValue = 0;
            $scope.conditionItem.conditionList.forEach(function(condition){
                if(condition.ticked == true)
                    selectedConditionTypeId = condition.id;
            })
            switch(selectedConditionTypeId){
                case 1:
                    $scope.conditionOperator = 1;
                    $scope.conditionValue = 1;
                    if($scope.conditionItem.comparision != undefined && $scope.conditionItem.comparision.length == 3){
                        $scope.conditionItem.comparision.splice(2,1);
                    }                            
                    break
                case 2:
                    $scope.conditionOperator = 2;
                    $scope.conditionValue = 1;
                    if($scope.conditionItem.comparision != undefined && $scope.conditionItem.comparision.length == 3){
                        $scope.conditionItem.comparision.splice(0,2);
                    }
                    break;
                case 3:
                    $scope.conditionOperator = 2;
                    $scope.conditionValue = 1;
                    if($scope.conditionItem.comparision != undefined && $scope.conditionItem.comparision.length == 3){
                        $scope.conditionItem.comparision.splice(0,2);
                    }
                    break;
                case 4:
                    $scope.conditionOperator = 2;
                    $scope.conditionValue = 1;
                    if($scope.conditionItem.comparision != undefined && $scope.conditionItem.comparision.length == 3){
                        $scope.conditionItem.comparision.splice(0,2);
                    }
                    break;
                case 5:
                    $scope.conditionOperator = 2;
                    $scope.conditionValue = 1;
                    if($scope.conditionItem.comparision != undefined && $scope.conditionItem.comparision.length == 3){
                        $scope.conditionItem.comparision.splice(0,2);
                    }
                    break;
                case 6:
                    $scope.conditionOperator = 1;
                    $scope.conditionValue = 1;
                    if($scope.conditionItem.comparision != undefined && $scope.conditionItem.comparision.length == 3){
                        $scope.conditionItem.comparision.splice(2,1);
                    }
                    break;
                case 7:
                    $scope.conditionOperator = 1;
                    $scope.conditionValue = 1;
                    if($scope.conditionItem.comparision != undefined && $scope.conditionItem.comparision.length == 3){
                        $scope.conditionItem.comparision.splice(2,1);
                    }
                    break;
                case 8:
                    $scope.conditionOperator = 2;
                    $scope.conditionValue = 2;
                    if($scope.conditionItem.comparision != undefined && $scope.conditionItem.comparision.length == 3){
                        $scope.conditionItem.comparision.splice(1,2);
                    }
                    break;
                case 9:
                    $scope.conditionOperator = 1;
                    $scope.conditionValue = 1;
                    if($scope.conditionItem.comparision != undefined && $scope.conditionItem.comparision.length == 3){
                        $scope.conditionItem.comparision.splice(2,1);
                    }
                    break;
                case 10:
                    $scope.conditionOperator = 2;
                    $scope.conditionValue = 1;
                    if($scope.conditionItem.comparision != undefined && $scope.conditionItem.comparision.length == 3){
                        $scope.conditionItem.comparision.splice(0,2);
                    }
                    break;
                case 11:
                    $scope.conditionOperator = 2;
                    $scope.conditionValue = 1;
                    if($scope.conditionItem.comparision != undefined && $scope.conditionItem.comparision.length == 3){
                        $scope.conditionItem.comparision.splice(0,2);
                    }
                    break;
                case 12:
                    $scope.conditionOperator = 1;
                    $scope.conditionValue = 1;
                    if($scope.conditionItem.comparision != undefined && $scope.conditionItem.comparision.length == 3){
                        $scope.conditionItem.comparision.splice(2,1);           
                    }
                    break;
            }
            if($scope.reload == true && $scope.enableWatch == true && $scope.conditionIndex == $scope.conditionListLength-1){
                $scope.updateReload();
            }  
        } else{
            var selectedConditionId = 0;
            angular.forEach($scope.conditionItem.conditionList, function(condition){
                if(condition.ticked == true){
                    selectedConditionId = condition.id;
                }
            })
            checkCondition(selectedConditionId);
        }
    }            

    $scope.selectCondition = function(data){              
        if($scope.reload == false && $scope.editRow == false){
            $scope.editRow = true;
        } 
        if(data.comparision != undefined){
            $scope.addNewCondition = true;
            checkAddNewCondition();
        } else{
            if($scope.editRow == true){
                $scope.addNewCondition = true;
                checkAddNewCondition();
            } else{
                $scope.conditionOperator = null;
                $scope.conditionValue = null;
            }                        
        }                                                                                                       
    };

    $scope.$watch('selectedCondition', function(newValue, oldValue){
        if(newValue !== oldValue && newValue !== undefined && newValue.length > 0 
            && $scope.addNewCondition == false && $scope.enableWatch == true && $scope.reload == true) {                       
            checkAddNewCondition();
        } else{
            checkAddNewCondition();
        }
    }, true)

    function checkCondition(selectedConditionId){
        var countCondition = 0;  
        var sameCondition = false; 
        var conditionMatch = null;
        $scope.conditionListObject.forEach(function(addedCondition){
            countCondition += 1;
            angular.forEach(addedCondition.match, function(match){
                if(match.ticked == true){
                    conditionMatch = match.id;
                }
            })
            if(addedCondition.comparision != undefined && $scope.conditionListObject.indexOf(addedCondition) != $scope.conditionIndex){
                angular.forEach(addedCondition.conditionList, function(cond){                                    
                    if(cond.ticked == true && cond.id == selectedConditionId && $scope.conditionListObject.length > 1){
                        switch(cond.id){
                            case 1:
                                if(conditionMatch == 1){
                                    sameCondition = true;                                                    
                                } else if(conditionMatch == 2){
                                    $scope.conditionItem.match[0].ticked = false;
                                    $scope.conditionItem.match[1].ticked = true;                                                    
                                }
                                break;
                            case 2:
                                sameCondition = true;
                                break;
                            case 3:
                                sameCondition = true;
                                break;
                            case 4:
                                sameCondition = true;
                                break;
                            case 5:
                                sameCondition = true;
                                break;
                            case 6:
                                if(conditionMatch == 1){
                                    sameCondition = true;
                                } else if(conditionMatch == 2){
                                    $scope.conditionItem.match[0].ticked = false;
                                    $scope.conditionItem.match[1].ticked = true;                                                    
                                }
                                break;
                            case 7:
                                if(conditionMatch == 1){
                                    sameCondition = true;
                                } else if(conditionMatch == 2){
                                    $scope.conditionItem.match[0].ticked = false;
                                    $scope.conditionItem.match[1].ticked = true;                                                    
                                }
                                break;
                            case 8:
                                break;
                            case 9:
                                break;
                            case 10:
                                sameCondition = true;
                                break;
                            case 11:
                                sameCondition = true;
                                break;
                            case 12:
                                if(conditionMatch == 1){
                                    sameCondition = true;
                                } else if(conditionMatch == 2){
                                    $scope.conditionItem.match[0].ticked = false;
                                    $scope.conditionItem.match[1].ticked = true;                                                    
                                }
                                break;
                        }                                                                 
                    }
                })                                
            }
            if(countCondition == $scope.conditionListObject.length && $scope.conditionListObject.length > 1 && sameCondition == true){
                $scope.conditionItem.conditionList.forEach(function(condition){
                    condition.ticked = false;
                })
                $scope.conditionOperator = null;
                $scope.conditionValue = null;
                var errorModalInstance = $modal.open({
                    scope: $scope,
                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=07292016',
                    windowClass: 'modal-dialog-mention-error'
                });
                $scope.errorModalInstance = errorModalInstance;
                $scope.errorMessage = "You already added a condition related to this issue";
            } else if(countCondition == $scope.conditionListObject.length && sameCondition == false){
                setConditionData(selectedConditionId);
            }                           
        })
    }

    $scope.countries = [];
    angular.forEach(definitions.countries, function(country) {
        if(country.isActive == 1) {
            $scope.countries.push(country);
        }
    })
    
    function setConditionData(conditionId){
        $scope.conditionOperator = 0;
        $scope.conditionValue = 0;
        var getConditionCOmparisionUrl = $rootScope.apiUrl + 'notification/getConditionComparision';
        $http.get(getConditionCOmparisionUrl, {loader: false})
        .success(function(responseGetConditionComparision){
            /*$scope.conditionItem.comparision = responseGetConditionComparision.data;*/                     
            switch(conditionId){
                case 1:                            
                    $scope.conditionOperator = 1;
                    $scope.conditionValue = 1;
                    if($scope.conditionItem.valueToCompare == undefined 
                        || $scope.reload != true && $scope.editRow == true){
                        $scope.conditionItem.comparision = responseGetConditionComparision.data;
                        $scope.conditionItem.comparision.splice(2,1);
                        $scope.conditionItem.comparision[0].ticked = true;
                        $scope.conditionItem.valueToCompare = $scope.countries;
                        $scope.conditionItem.valueToCompare[0].ticked = true;
                    }                            
                    break;
                case 2:                            
                    $scope.conditionOperator = 2;
                    $scope.conditionValue = 1;
                    if($scope.conditionItem.valueToCompare == undefined
                        || $scope.reload != true && $scope.editRow != false){
                        $scope.conditionItem.comparision = responseGetConditionComparision.data;
                        $scope.conditionItem.comparision.splice(0,2);
                        $scope.conditionItem.comparision[0].ticked = true;
                        $scope.conditionItem.valueToCompare = $scope.growth;
                        $scope.conditionItem.valueToCompare.forEach(function(data){
                            data.name = data.value + '%';
                        })
                        $scope.conditionItem.valueToCompare[0].ticked = true;
                    }                            
                    break;
                case 3:                            
                    $scope.conditionOperator = 2;
                    $scope.conditionValue = 1;
                    if($scope.conditionItem.valueToCompare == undefined
                        || $scope.reload != true && $scope.editRow != false){
                        $scope.conditionItem.comparision = responseGetConditionComparision.data;
                        $scope.conditionItem.comparision.splice(0,2);
                        $scope.conditionItem.comparision[0].ticked = true;
                        $scope.conditionItem.valueToCompare = $scope.minEngagementList;
                        $scope.conditionItem.valueToCompare.forEach(function(engagementNumber){
                            engagementNumber.name = Number(engagementNumber.value).toLocaleString('en');
                        })
                        $scope.conditionItem.valueToCompare[0].ticked = true;
                    }                            
                    break;
                case 4:                            
                    $scope.conditionOperator = 2;
                    $scope.conditionValue = 1;
                    if($scope.conditionItem.valueToCompare == undefined
                        || $scope.reload != true && $scope.editRow != false){
                        $scope.conditionItem.comparision = responseGetConditionComparision.data;
                        $scope.conditionItem.comparision.splice(0,2);
                        $scope.conditionItem.comparision[0].ticked = true;
                        $scope.conditionItem.valueToCompare = $scope.growth;
                        $scope.conditionItem.valueToCompare.forEach(function(data){
                            data.name = data.value + '%';
                        })
                        $scope.conditionItem.valueToCompare[0].ticked = true;
                    }                            
                    break;
                case 5:                            
                    $scope.conditionOperator = 2;
                    $scope.conditionValue = 1;
                    if($scope.conditionItem.valueToCompare == undefined
                        || $scope.reload != true && $scope.editRow != false){
                        $scope.conditionItem.comparision = responseGetConditionComparision.data;
                        $scope.conditionItem.comparision.splice(0,2);
                        $scope.conditionItem.comparision[0].ticked = true;
                        $scope.conditionItem.valueToCompare = $scope.minImpactList;
                        $scope.conditionItem.valueToCompare.forEach(function(data){
                            data.name = data.value + '%';
                        })
                        $scope.conditionItem.valueToCompare[0].ticked = true;
                    }                            
                    break;
                case 6:                            
                    $scope.conditionOperator = 1;
                    $scope.conditionValue = 1;
                    if($scope.conditionItem.valueToCompare == undefined
                        || $scope.reload != true && $scope.editRow != false){
                        $scope.conditionItem.comparision = responseGetConditionComparision.data;
                        $scope.conditionItem.comparision.splice(2,1);
                        $scope.conditionItem.comparision[0].ticked = true;
                        var getVerticalsUrl = $rootScope.apiUrl + 'notification/getVerticals';
                        $http.get(getVerticalsUrl, {loader: false})
                        .success(function(responseGetVerticals){
                            $scope.conditionItem.valueToCompare = responseGetVerticals.data;
                            $scope.conditionItem.valueToCompare.splice(0,1);
                            $scope.conditionItem.valueToCompare[0].ticked = true;
                        });
                    }                            
                    break;
                case 7:                            
                    $scope.conditionOperator = 1;
                    $scope.conditionValue = 1;
                    if($scope.conditionItem.valueToCompare == undefined
                        || $scope.reload != true && $scope.editRow != false){
                        $scope.conditionItem.comparision = responseGetConditionComparision.data;
                        $scope.conditionItem.comparision.splice(2,1);
                        $scope.conditionItem.comparision[0].ticked = true;
                        var getLanguagesUrl = $rootScope.apiUrl + 'admin/getLanguagesOfInterestingCountries';
                        $http.get(getLanguagesUrl, {loader: false})
                        .success(function(response){
                            $scope.conditionItem.valueToCompare = response.data;
                            $scope.conditionItem.valueToCompare[0].ticked = true;
                        });
                    }                            
                    break;
                case 8:                            
                    $scope.conditionOperator = 2;
                    $scope.conditionValue = 2;
                    $scope.conditionItem.comparision = responseGetConditionComparision.data;
                    $scope.conditionItem.comparision.splice(1,2);
                    $scope.conditionItem.comparision[0].ticked = true;
                    var valueToCompareObject = {
                        id: 0,
                        name: ""
                    };
                    if($scope.conditionItem.valueToCompare == undefined){
                        $scope.conditionItem.valueToCompare = valueToCompareObject;     
                    } else if($scope.reload != true && $scope.editRow != false){
                        $scope.conditionItem.valueToCompare.name = "";
                    } 
                    break;
                case 9:                            
                    $scope.conditionOperator = 1;
                    $scope.conditionValue = 1;
                    if($scope.conditionItem.valueToCompare == undefined
                        || $scope.reload != true && $scope.editRow != false){
                        $scope.conditionItem.comparision = responseGetConditionComparision.data;
                        $scope.conditionItem.comparision.splice(2,1);
                        $scope.conditionItem.comparision[0].ticked = true;
                        var getPlatformsUrl = $rootScope.apiUrl + 'notification/getPlatforms';
                        $http.get(getPlatformsUrl, {loader: false})
                        .success(function(responseGetPlatforms){
                            $scope.conditionItem.valueToCompare = responseGetPlatforms.data;
                            $scope.conditionItem.valueToCompare[0].ticked = true;
                        });
                    }                            
                    break;
                case 10:                            
                    $scope.conditionOperator = 2;
                    $scope.conditionValue = 1;
                    if($scope.conditionItem.valueToCompare == undefined
                        || $scope.reload != true && $scope.editRow != false){
                        $scope.conditionItem.comparision = responseGetConditionComparision.data;
                        $scope.conditionItem.comparision.splice(0,2);
                        $scope.conditionItem.comparision[0].ticked = true;
                        $scope.conditionItem.valueToCompare = $scope.growth;
                        $scope.conditionItem.valueToCompare.forEach(function(data){
                            data.name = data.value + '%';
                        })
                        $scope.conditionItem.valueToCompare[0].ticked = true;
                    }   
                    break;                         
                case 11:                            
                    $scope.conditionOperator = 2;
                    $scope.conditionValue = 1;
                    if($scope.conditionItem.valueToCompare == undefined
                        || $scope.reload != true && $scope.editRow != false){
                        $scope.conditionItem.comparision = responseGetConditionComparision.data;
                        $scope.conditionItem.comparision.splice(0,2);
                        $scope.conditionItem.comparision[0].ticked = true;
                        $scope.conditionItem.valueToCompare = $scope.minReachList;
                        $scope.conditionItem.valueToCompare.forEach(function(reachNumber){
                            reachNumber.name = Number(reachNumber.value).toLocaleString('en');
                        })
                        $scope.conditionItem.valueToCompare[0].ticked = true;
                    }                            
                    break;
                case 12:                            
                    $scope.conditionOperator = 1;
                    $scope.conditionValue = 1;
                    if($scope.conditionItem.valueToCompare == undefined
                        || $scope.reload != true && $scope.editRow != false){
                        $scope.conditionItem.comparision = responseGetConditionComparision.data;
                        $scope.conditionItem.comparision.splice(2,1);
                        $scope.conditionItem.comparision[0].ticked = true;
                        var getTopicsUrl = $rootScope.apiUrl + 'notification/getTopics';
                        $http.get(getTopicsUrl, {loader: false})
                        .success(function(responseGetTopics){
                            $scope.conditionItem.valueToCompare = responseGetTopics.data;
                            $scope.conditionItem.valueToCompare.splice(0,1);
                            $scope.conditionItem.valueToCompare[0].ticked = true;
                        });
                    }                            
                    break;
            }               
        });
    }

    $scope.selectConditionMatch = function(conditionData){
        var selectedMatch = null;
        var selectedConditionType = null;
        var differentMatch = false;
        var conditionTypeName = "";

        angular.forEach(conditionData.match, function(matchItem){
            if(matchItem.ticked == true){
                selectedMatch = matchItem.id;
            }
        })

        angular.forEach(conditionData.conditionList, function(conditionItem){
            if(conditionItem.ticked == true){
                selectedConditionType = conditionItem.id;
            }
        })

        $scope.conditionListObject.forEach(function(conditionObject){
            if($scope.conditionListObject.indexOf(conditionObject) != $scope.conditionIndex){
                angular.forEach(conditionObject.conditionList, function(conditionTypeItem){
                    if(conditionTypeItem.ticked == true && conditionTypeItem.id == selectedConditionType
                        && (selectedConditionType == 1 || selectedConditionType == 6 || selectedConditionType == 7
                            || selectedConditionType == 12)){

                        angular.forEach(conditionObject.match, function(conditionMatchItem){
                            if(conditionMatchItem.ticked == true && conditionMatchItem.id == 2 && conditionMatchItem.id != selectedMatch){
                                differentMatch = true;
                            }
                        })                                
                    }
                })
            }                    
        })
        if(differentMatch){
            $scope.conditionItem.match.forEach(function(matchItem){
                if(matchItem.id == 2){
                    matchItem.ticked = true;
                } else{
                    matchItem.ticked = false;
                }
            })
            var errorModalInstance = $modal.open({
                scope: $scope,
                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=07292016',
                windowClass: 'modal-dialog-mention-error'
            });
            $scope.errorModalInstance = errorModalInstance;
            $scope.errorMessage = "You already added a condition related to this issue";
        }
    }        
})